<div class="placement-excellence-container-fluid">
  <div class="row">
    @for (item of tableItems; track item) {
      <div>
        <div class="col">
          <app-placement-excellence-content-card
            coreStep="{{ item.coreStep }}"
            generalTask="{{ item.generalTask }}"
            actionDetails="{{ item.actionDetails }}"
            responsibility="{{ item.responsibility }}"
            cemRequirement="{{ item.cemRequirement }}"
            guidanceReferenceLink="{{ item.guidanceReferenceLink }}">
          </app-placement-excellence-content-card>
        </div>
      </div>
    }
  </div>
</div>
